export default interface AccountNoDetailedType {
    id: number;
    name: string;
}

export const accountNoDetailedTypeDefaultProps: AccountNoDetailedType = {
    id: 0,
    name: '',
}